const anchor = (value: string) => `/${value}/`;

export const nswContractExchangeDocuSignAnchors = {
  sellerSignature: (index: number) =>
    anchor(`NSWCESELLERSIGSH${index.toString().padStart(6, '0')}`),
  buyerSignature: (index: number) => anchor(`NSWCEBUYERSSIGSH${index.toString().padStart(6, '0')}`),
  sellerInitial: (index: number) => anchor(`NSWCESELLERINITH${index.toString().padStart(6, '0')}`),
  buyerInitial: (index: number) => anchor(`NSWCEBUYERSINITH${index.toString().padStart(6, '0')}`),
} as const;
